/*
  Electric Cherries animation layer.
  - [data-ec-reveal]        : fades/slides in when scrolled into view; direct
                              children stagger via --ec-i custom property.
  - [data-ec-count="11342"] : counts up from 0 when scrolled into view.
                              Non-digit prefix/suffix characters are preserved.
  Respects prefers-reduced-motion.
*/
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markInView(el) {
    el.classList.add('ec-inview');
  }

  var revealEls = document.querySelectorAll('[data-ec-reveal]');
  revealEls.forEach(function (el) {
    // Opt in to the hidden pre-reveal state only when this script actually
    // runs — keeps content visible in no-JS contexts and the theme editor's
    // auto-generated section previews.
    if (!reduced) el.classList.add('ec-anim-ready');
    Array.prototype.forEach.call(el.children, function (child, i) {
      child.style.setProperty('--ec-i', i);
    });
  });

  function animateCount(el) {
    var raw = (el.getAttribute('data-ec-count') || el.textContent).trim();
    var match = raw.match(/([\d,.]+)/);
    if (!match) return;
    var numStr = match[1];
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;
    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + numStr.length);
    var useCommas = numStr.indexOf(',') !== -1;
    var duration = 1600;
    var start = null;

    function fmt(n) {
      var v = Math.round(n);
      return useCommas ? v.toLocaleString('en-NZ') : String(v);
    }

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }

    if (reduced) {
      el.textContent = raw;
    } else {
      el.textContent = prefix + fmt(0) + suffix;
      requestAnimationFrame(step);
    }
  }

  if (!('IntersectionObserver' in window)) {
    revealEls.forEach(markInView);
    document.querySelectorAll('[data-ec-count]').forEach(animateCount);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        if (el.hasAttribute('data-ec-count')) {
          animateCount(el);
        } else {
          markInView(el);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  revealEls.forEach(function (el) {
    if (reduced) markInView(el);
    else io.observe(el);
  });
  document.querySelectorAll('[data-ec-count]').forEach(function (el) {
    io.observe(el);
  });
})();

/*
  Desktop nav: hover opens the dropdown, clicking the parent item navigates
  to its own page (data-url stamped on the <summary> by the header snippets).
  Touch devices and keyboard users keep Dawn's default click/Enter-to-toggle.
*/
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('header-menu').forEach(function (menu) {
    var details = menu.querySelector('details');
    var summary = menu.querySelector('summary');
    if (!details || !summary) return;
    var closeTimer;

    menu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (!details.open) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    menu.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });

    summary.addEventListener('click', function (e) {
      var url = summary.getAttribute('data-url');
      // e.detail === 0 means keyboard activation — keep toggle for accessibility
      if (!url || url === '#' || e.detail === 0) return;
      e.preventDefault();
      window.location.href = url;
    });
  });
})();
